import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthenticationService, Logger } from '@app/core';

import { UserManager } from 'oidc-client-ts';

import { RealTimeNotificationService } from '@shared/services/realTimeNotification/real-time-notification.service';
import { SignalrService } from '@app/core/signalr.service';
import { environment } from '@env/environment';
import { NgxPermissionsService, NgxPermissionsObject } from 'ngx-permissions';

import { OAuthService } from 'angular-oauth2-oidc';
import { WebStorageStateStore } from 'oidc-client-ts';
import { MyStartupService } from '@app/app.service';
import { LoaderService } from '@app/core/loader.service';
import { NotificationsService } from '@shared/services/notifications.service';
import { guid } from '@app/core/helpers';
import { ThemesService } from '@projects/shared/src/app/features/setting/services/themes.service';
const log = new Logger('SsoComponent');

@Component({
  selector: 'app-sso',
  templateUrl: './sso.component.html',
  styleUrls: ['./sso.component.scss'],
})
export class SsoComponent implements OnInit {
  token!: string;
  public loggedIn!: boolean;
  public identity!: any;
  error!: string;
  permissions!: NgxPermissionsObject;

  constructor(
    private routeParam: ActivatedRoute,
    private authService: AuthenticationService,
    private router: Router,
    private realTimeNotificationService: RealTimeNotificationService,
    private signalRService: SignalrService,
    private ngxpermissions: NgxPermissionsService,
    private oauthService: OAuthService,
    private loaderService: LoaderService,
    private MystartupService: MyStartupService,
    private notificationsService: NotificationsService,
    private themeService: ThemesService
  ) {}

  ngOnInit() {
    this.routeParam.queryParams.subscribe((params) => {
      this.token = params['ssoParam'];
      let clientName = params['c'];
      if (clientName != null && clientName != '') {
        clientName = clientName.replace(/^"(.*)"$/, '$1');
      }

      if (this.token) {
        console.trace();
        //log.error('[sso.component.ts] line 55, window.localStorage clear() called');
        localStorage.clear();
        localStorage.setItem('isSSOLogin', JSON.stringify(true));
        localStorage.setItem('ssoToken', JSON.stringify(this.token));
        //localStorage.setItem('ssoClient', JSON.stringify('TCISSO'));
        this.getValuesFromToken();
      } else if (clientName && clientName != '') {
        this.authService.getSSOConfiguration(clientName).subscribe((response: any) => {
          if (response) {
            console.trace();
            //log.error('[sso.component.ts] line 365, localStorage clear() called');
            localStorage.clear();
            localStorage.setItem('isSSOLogin', JSON.stringify(true));
            localStorage.setItem('ssoClient', JSON.stringify(clientName));
            this.initSSO(response.Data);
          } else {
            localStorage.removeItem('isSSOLogin');
            localStorage.removeItem('ssoClient');

            this.router.navigate(['/logoutsso']);
          }
        });
      } else {
        const client = JSON.parse(localStorage.getItem('ssoClient') || 'null');
        if (client != 'TCISSO') {
          const client = JSON.parse(localStorage.getItem('ssoClient') || 'null');
          if (client != null && client != '') {
            this.initSSO(client);
          } else {
            this.router.navigate(['/page-not-found']);
          }
        } else if (client === 'TCISSO') {
          this.token = JSON.parse(localStorage.getItem('ssoToken') || 'null');
          localStorage.setItem('isSSOLogin', JSON.stringify(true));

          this.getValuesFromToken();
        } else {
          localStorage.removeItem('isSSOLogin');
          localStorage.removeItem('ssoClient');

          this.router.navigate(['/logoutsso']);
        }
      }
    });
  }

  getValuesFromToken() {
    let code = decodeURI(this.token);
    code = code.replace(/\s+/g, '+');
    this.authService.getTokenParams({ Token: code }).subscribe((param) => {
      localStorage.setItem('cvp_session_id', '(S(' + param.SessionId + '))');
      localStorage.setItem('ssoConfig', JSON.stringify(param));

      this.authService.ssoLogin(param).subscribe((response) => {
        if (response) {
          this.initGenericSSO(param.Email);
        } else {
          this.router.navigate(['/unauthorized']);
        }
      });
    });
  }

  initGenericSSO(username: string) {
    const ssoConfig = JSON.parse(localStorage.getItem('ssoConfig') || 'null');
    this.oauthService.tokenEndpoint = ssoConfig.Authority + '/connect/token';
    this.oauthService.clientId = ssoConfig.IdentityClientId;
    this.oauthService.scope = ssoConfig.Scope;
    this.oauthService.dummyClientSecret = ssoConfig.Secret;

    this.oauthService.fetchTokenUsingPasswordFlow(username, 'password').then((resp: any) => {
      if (resp) {
        const res = {
          access_token: resp.access_token,
          expiry: 864000000000,
        };

        this.authService.saveSsoAuthToken(res);
        this.saveAuthData(res);
      }
    });
  }

  initSSO(clientId: string) {
    this.authService.initSSO(clientId);
    const mgr = this.authService.getUserManager();
    this.authService.getCurrentUser().subscribe({
      next: (value) => {
        if (value) {
          this.authService.checkTokenExpiry(value.expires_at);
          this.authService.isLoggedIn = true;
          this.loggedIn = true;
          this.identity = value;
          this.initUser();
        } else {
          this.loggedIn = false;
          this.identity = '';
          this.authService.isLoggedIn = false;
          localStorage.setItem('isSSOLogin', JSON.stringify(true));
          localStorage.setItem('ssoClient', JSON.stringify(clientId));
          this.authService.signinRedirect();
        }
      },
      error: (e) => {
        // console.log(e);
        this.loaderService.showMain = false;
        this.router.navigate(['/oops']);
      },
    });
  }

  initUser() {
    const res = {
      access_token: this.identity.access_token,
      expiry: this.identity.expires_at,
    };

    this.authService.saveSsoAuthToken(res);

    this.saveAuthData(res);

    // check if sso user exist in baseline project
    this.authService.isUserExist(this.identity.profile.sub).subscribe((response) => {
      if (response) {
        // User already exist
        this.saveAuthData(res);
      } else {
        // Create SSO user in baseline DB

        const user = {
          Id: this.identity.profile.sub,
          ClientId: this.identity.profile.ClientId,
          DefaultLanguage: this.identity.profile.DefaultLanguage,
          Email: this.identity.profile.Email,
          FirstName: this.identity.profile.FirstName,
          IsFromSSO: true,
          LastName: this.identity.profile.LastName,
          MarketId: this.identity.profile.MarketId,
          RoleId: this.identity.profile.RoleId,
        };

        this.authService.createUser(user).subscribe((value) => {
          if (value != null) {
            this.saveAuthData(res);
          }
        });
      }
    });
  }

  saveAuthData(res: any) {
    this.authService.storeAuthData(res).subscribe(
      (response) => {
        response.token = this.authService.getSSOToken();
        const data = this.authService.onSignIn(response);

        if (environment.signalRConfigured) {
          this.signalRService.init();
          this.realTimeNotificationService.init();
          this.realTimeNotificationService.subscribeListeners();
        }
        this.authService.getLanguage().subscribe((langResponse) => {
          this.MystartupService.data = langResponse;
          // localStorage.setItem('translations', JSON.stringify(langResponse));
          localStorage.setItem('translations', JSON['makeStringify'](langResponse));
          this.permissions = this.ngxpermissions.getPermissions();
          const Admin = this.permissions['Admin'] ? true : false;
          const Reporting = this.permissions['Reporting'] ? true : false;

          this.loaderService.showMain = false;
          if (localStorage.getItem('loginNotificationId') == null) {
            const id: string = guid();
            localStorage.setItem('appNotifyId', id);
            const notifyData = { message: 'Login Successful', pageName: 'Login', module: 'Login', appNotifyId: id };
            this.notificationsService.ActivityNonRequestNotification(notifyData, true);
          }
          if (Reporting) {
            this.router.navigate(['/' + environment.reportingRoutePrefix]);
          } else if (Admin) {
            this.router.navigate(['/' + environment.reflecxRoutePrefix]);
          } else {
            this.router.navigate(['/unauthorized']);
          }
        });

        // sync theme
        this.themeService.syncSelectedTheme();
      },
      (reason) => {
        //  HideLoader();
        switch (reason.status) {
          case -1: {
            this.error = 'Some error occurred. Please check your internet connection or try again';
            this.loaderService.showMain = false;

            break;
          }
          case 400: {
            this.error = reason.Message;
            this.loaderService.showMain = false;

            break;
          }
          case 500: {
            this.error = reason.error.ExceptionMessage;
            this.loaderService.showMain = false;

            break;
          }
        }
      }
    );
  }
}
